(() => {
  if (customElements.get('annoell-simple-video')) return;
  class AnnoellSimpleVideo extends HTMLElement {
    connectedCallback() {
      // Deferred on initial load; microtask also supports theme-editor insertion.
      queueMicrotask(() => {
        if (!this.isConnected || this.abortController) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('.annoell-simple-video__toggle');
        if (!this.video || !this.button) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.video.controls = false;
        this.video.disablePictureInPicture = true;
        this.video.disableRemotePlayback = true;
        this.button.addEventListener('click', () => this.togglePlayback(), options);
        this.addEventListener('contextmenu', event => event.preventDefault(), options);
        for (const event of ['play', 'pause', 'ended', 'error']) {
          this.video.addEventListener(event, () => this.syncState(), options);
        }
        this.syncState();
      });
    }
    disconnectedCallback() {
      this.video?.pause();
      this.abortController?.abort();
      this.abortController = null;
      this.pendingPlay = false;
    }
    syncState() {
      const playing = !this.video.paused && !this.video.ended && !this.video.error;
      this.toggleAttribute('data-playing', playing);
      this.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
    async togglePlayback() {
      if (this.pendingPlay || !this.video.paused) {
        this.pendingPlay = false;
        this.video.pause();
        this.syncState();
        return;
      }
      if (this.video.ended) this.video.currentTime = 0;
      this.pendingPlay = true;
      try {
        await this.video.play();
      } catch {
        // Keep the play button available if playback is blocked or loading fails.
      } finally {
        this.pendingPlay = false;
        this.syncState();
      }
    }
  }
  customElements.define('annoell-simple-video', AnnoellSimpleVideo);
})();
